import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponse } from 'src/app/shared/models/qcResponse.model';
import { RolesInDocument } from '../models/user.models';

export const GetUserManagementRoles = createAction(
  '[User Management: Policy Documents]: Get User Management Roles',
);

export const GetUserManagementRolesSuccess = createAction(
  '[User Management: Policy Documents]: Get User Management Roles Success',
  props<{ res: RolesInDocument[]; literals: any }>(),
);

export const GetUserManagementRolesFailed = createAction(
  '[User Management: Policy Documents]: Get User Management Roles Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const RolesInDocumentChanged = createAction(
  '[User Management: Policy Documents]: Roles In Document Changed',
  props<{ role: string }>(),
);

export const EditUserPolicy = createAction(
  '[User Management: Policy Documents]: Edit User Policy',
  props<{ row: any }>(),
);

export const EditPolicyRolesSuccess = createAction(
  '[User Management: Policy Documents]: Edit Policy Roles Success',
  props<{ res: any }>(),
);

export const EditPolicyRolesFailed = createAction(
  '[User Management: Policy Documents]: Edit Policy Roles Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ProgressChanged = createAction(
  '[User Management: Policy Documents]: Progress Changed',
);

export const RemoveRole = createAction(
  '[User Management: Policy Documents]: Remove Role',
  props<{ role: any }>(),
);

export const PolicyNameChanged = createAction(
  '[User Management: Policy Documents]: Policy Name Changed',
  props<{ policyName: string }>(),
);

export const PolicyDescriptionChanged = createAction(
  '[User Management: Policy Documents]: Policy Description Changed',
  props<{ policyDescription: string }>(),
);

export const SearchFilterChanged = createAction(
  '[User Management: Policy Documents]: Search Filter Changed',
  props<{ searchFilter: string }>(),
);

export const UserSubmitted = createAction('[User Management: Policy Documents]: User Submitted');

export const SaveUserPolicy = createAction('[User Management: Policy Documents]: Save User Policy');

export const SaveUserPolicySuccess = createAction(
  '[User Management: Policy Documents]: Save User Policy Success',
  props<{ res: QcResponse }>(),
);

export const SaveUserPolicyFailed = createAction(
  '[User Management: Policy Documents]: Save User Policy Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateNewPolicy = createAction(
  '[User Management: Policy Documents]: Create New Policy',
);
